import { render, staticRenderFns } from "./CreatedOrEditedPaymentDetails.vue?vue&type=template&id=64ffae20&scoped=true&"
import script from "./CreatedOrEditedPaymentDetails.vue?vue&type=script&lang=js&"
export * from "./CreatedOrEditedPaymentDetails.vue?vue&type=script&lang=js&"
import style0 from "./CreatedOrEditedPaymentDetails.vue?vue&type=style&index=0&id=64ffae20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ffae20",
  null
  
)

export default component.exports